<script>
import mixinComponent from '../../Mixins/mixinComponent'
import { globalVariablesMixin } from '../../Mixins/global'
import BlockContent from '../UI/Content/BlockContent.vue'
import SimulationRating from './SimulationRating.vue'
import SimulationProfitability from './SimulationProfitability.vue'
import SimulationRentSelector from './RentSelector/SimulationRentSelector.vue'
import SimulationHeadband from './SimulationHeadband.vue'

export default {
  components: { SimulationHeadband, SimulationRentSelector, SimulationProfitability, SimulationRating, BlockContent },
  mixins: [mixinComponent, globalVariablesMixin],

  props: {
    simulationId: { type: Number, required: true },
    simulation: { type: Object, required: true },
    def: { type: Object, required: true },
    decisions: { type: Array, default: [] },
  },

  data() {
    return {
      updateDuration: false,
      profitability: {},
      modalReady: false,
    }
  },

  methods: {
    updateSimulation() {
      this.getProfitability()
      this.$emit('update-simulation')
    },
    sendReset() {
      let url =
        window.location.protocol +
        '//' +
        window.location.hostname +
        '/devis/simulation.php?i=' +
        this.simulationId +
        '&reset=true&index=creer'

      if (this.simulation.platformParam && this.simulation.platformParam.id) {
        url += '&pp=' + this.simulation.platformParam.id
      }
      window.location = url
    },

    rentUpdated(rent) {
      this.getProfitability()
      this.setValue(this.simulation.finance, 'rentInfo', rent)
      for (const [key, oldRent] of Object.entries(this.simulation.finance.rents)) {
        if (oldRent.id === rent.id) {
          //mets à jour en ajoutant un nouveau tableau
          this.simulation.finance.rents[key] = {
            ...rent,
          }
        }
      }
      this.$parent.getAlert()
    },
    serviceUpdated(services) {
      this.$emit('service-updated', services)
      this.getProfitability()
    },
    getProfitability() {
      this.getJSON('quotations/' + this.simulationId + '/profitability').then((profitability) => {
        this.$root.addValue(this.profitability, profitability)
      })
    },

    supprimer() {
      this.deleteJSON('quotations/' + this.simulationId, {}).then(
        (json) => {
          location = '/simulations/index.php'
        },
        (reason) => {
          alert(reason)
        },
      )
    },
    localRenderEntity(entity) {
      return this.$root.renderEntity(entity)
    },
  },

  mounted() {
    this.getProfitability()

    this.$nextTick(() => {
      // Ensure DOM is fully loaded
      const modalInfoBody = document.getElementById('modal-info-body')
      if (modalInfoBody) {
        this.modalReady = true
      }
    })
  },
}
</script>
<template>
  <div>
    <template v-if="simulation?.finance?.simulationAmount">
      <div class="row">
        <div class="col-md-12">
          <SimulationHeadband :simulation="simulation" :def="def" :update-duration="updateDuration" />
        </div>
      </div>
      <div class="row justify-content-center">
        <div
          :class="
            (conf.notation && simulation.decision && simulation.score) ||
            (conf.profitability && user.isBusinessMan && simulation.decision)
              ? 'col-xl-9 col-md-12'
              : 'col-md-12'
          "
        >
          <SimulationRentSelector
            v-if="simulationId && simulation?.finance.rents && modalReady"
            :theme="conf.theme_dir"
            :simulation="simulation"
            :def="def"
            :simulation-id="simulationId"
            :decisions="decisions"
            :show-ttc="conf.ttc"
            @update-simulation="updateSimulation"
            @rent-updated="rentUpdated"
            @service-updated="serviceUpdated"
          />
          <div v-else class="font-weight-bold text-warning">
            {{ simulation.noRent }}
          </div>
        </div>
        <div class="col-xl-3 col-md-4">
          <SimulationRating
            v-if="conf.notation && simulation.decision && simulation.score"
            :simulation="simulation"
            :def="def"
          />
          <SimulationProfitability
            v-if="conf.profitability && user.isBusinessMan"
            :rent="simulation.finance.rentInfo"
            :profitability="profitability"
          />
        </div>
      </div>
    </template>

    <div class="row" v-else>
      <div class="col-md-12">
        <BlockContent>
          <div class="row d-flex">
            <div class="col col-md-4 flex-fill">
              <h4>{{ $t('contract.information.menu_params', { data: $t('contract.information.contributor') }) }}</h4>
              <div class="row py-3 mb-3 mx-3 loading"></div>
              <div class="row py-3 mb-3 mx-3 loading"></div>
              <div class="row py-3 mb-3 mx-3 loading"></div>
              <div class="row py-3 mb-3 mx-3 loading"></div>
            </div>
            <div class="col col-md-4 flex-fill border-information">
              <h4>{{ $t('contract.information.menu_params', { data: $t('contract.list.table.equipment') }) }}</h4>
              <div class="row py-3 mb-3 mx-3 loading"></div>
              <div class="row py-3 mb-3 mx-3 loading"></div>
              <div class="row py-3 mb-3 mx-3 loading"></div>
              <div class="row py-3 mb-3 mx-3 loading"></div>
            </div>
            <div class="col col-md-4 flex-fill">
              <h4>{{ $t('contract.information.menu_params', { data: $t('contract.information.prestation') }) }}</h4>
              <div class="row py-3 mb-3 mx-3 loading"></div>
              <div class="row py-3 mb-3 mx-3 loading"></div>
              <div class="row py-3 mb-3 mx-3 loading"></div>
              <div class="row py-3 mb-3 mx-3 loading"></div>
            </div>
          </div>
        </BlockContent>
      </div>
    </div>

    <div class="modal modal-center" id="modal-info" tabindex="-1">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-body">
            <div id="modal-info-icon" class="swal2-icon"></div>
            <div id="modal-info-body"></div>
            <table id="message-info-table" class="table table-striped table-hover fs-16"></table>
          </div>
          <div class="modal-footer justify-content-center">
            &nbsp;<button type="button" class="btn btn-primary" data-dismiss="modal" e2e-button="close">
              {{ $t('main.close') }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
